import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

export const getTaxesPolicy = () => (dispatch) =>
  dispatch(
    actions.request({
      service: services.gma.content.taxes,
    })
  );
